import type { PageHelp } from "../../help/types";
import {
  DOCUMENTS_CONTEXTS,
  DOCUMENTS_DIALOG,
  LIST_VIEW_CONTEXT,
  PACKAGE_DIALOG_DETAILS,
  PACKAGE_DIALOG_RULES,
  PACKAGES_CARD_ACTIONS,
  PACKAGES_GETTING_AROUND,
  PACKAGES_LIST_VIEW,
  PACKAGES_READING_CARDS,
  PACKAGES_TOOLBAR,
  documentsDialogSteps,
  packageCardActionSteps,
  packageCardSteps,
  packageDialogSteps,
  packageListSteps,
  packagesFindSteps,
  packagesToolbarSteps,
} from "./help-steps";

export const companyPackagesPageHelp: PageHelp = {
  title: "Benefit packages",
  intro:
    "The packages of one benefit implementation of a client: what each package costs, who pays which share, who is eligible and how enrollment works. You reach this page from an implementation card on the Company profile; HR sees the same packages on the HR pages.",
  sections: [
    PACKAGES_GETTING_AROUND,
    PACKAGES_TOOLBAR,
    PACKAGES_READING_CARDS,
    PACKAGES_CARD_ACTIONS,
    PACKAGES_LIST_VIEW,
    PACKAGE_DIALOG_DETAILS,
    PACKAGE_DIALOG_RULES,
    DOCUMENTS_DIALOG,
  ],
  contexts: {
    "list-view": LIST_VIEW_CONTEXT,
    "package-dialog":
      'Click "Add Package" in the toolbar, or the edit icon on a package card or table row.',
    "package-dialog-add": 'Click "Add Package" in the toolbar.',
    "package-dialog-edit": "Click the edit icon on a package card or table row.",
    "documents-dialog":
      'Click the documents icon on a package card, or "Manage Documents" / "Add Documents" in a table row or in the package dialog.',
    ...DOCUMENTS_CONTEXTS,
  },
  tips: [
    "Grid view (cards) is the default. Switch to list view in the settings menu (gear icon in the header) to edit several packages directly in a table.",
    "A package belongs to exactly one implementation. Its currency, policy and validity come from the implementation; change those on the implementation, not here.",
    "Read-only roles see the cards without the action footer and cannot add or edit packages.",
  ],
  steps: [
    {
      selector: '[data-help="packages-breadcrumb"]',
      section: PACKAGES_GETTING_AROUND,
      title: "Go back to the company or implementation",
      body: "The breadcrumb shows country, company and implementation. Click the country to start over with another company, the company to return to its benefit categories, or the implementation name to return to the implementations of its category.",
    },
    ...packagesFindSteps,
    ...packagesToolbarSteps,
    {
      selector: '[data-help="benefit-card"]',
      section: PACKAGES_READING_CARDS,
      optional: true,
      title: "Read a package card",
      body: "Each card is one package: picture, name with the age range if one is set, and description (hover to read it in full). Drag a card to reorder the list, then save the order in the toolbar.",
    },
    ...packageCardSteps,
    ...packageCardActionSteps,
    ...packageListSteps,
    ...packageDialogSteps,
    ...documentsDialogSteps,
  ],
};
